<!-- Products -->

<pr-panel clazz="man">
  @if (showTitle && !simple) {
    <h3
      class="ea-panel-title text-blue semi-bold"
      [ngClass]="{ mbm: showTitle }"
    >
      {{ selectedProduct.title }}
      @if (selectedProduct.subtitle) {
        <span class="text-gray fs-16">{{ selectedProduct.subtitle }}</span>
      }
    </h3>
  }
  @if (showTitle && !simple) {
    <hr class="separator w-93" />
  }
  @if (!simple) {
    <pr-panel-header
      clazz="mtm pbn ptn"
      [title]="selectedProduct.bodyTitle"
    ></pr-panel-header>
  }
  <pr-panel-body clazz=" d-flex flex-col ">
    <div>
      <!-- <span class="fs-16 fw-600 semi-bold">Définition</span> -->
      <p class="fw-400">{{ selectedProduct.body }}</p>
    </div>
    <hr class="separator mb-15" />
    <div class="d-flex gap-s obj-risk">
      <div class="items-sheets">
        <span class="fs-16 fw-600 semi-bold">Objectifs</span>
        <div class="ea-options-container p-custom mt-12 flex-wrap">
          @for (objective of selectedProduct.objectives; track objective) {
            <div
              [style.background-color]="
                productsService.getObjective(objective).color
              "
            >
              <span
                class="fs-12 semi-bold"
                [style.color]="productsService.getObjective(objective).color"
                >{{ productsService.getObjective(objective).label }}</span
              >
            </div>
          }
        </div>
      </div>
      <div class="items-sheets">
        <span class="fs-16 fw-600 semi-bold">Niveau de risque moyen</span>
        <div class="item-pr-risk mt-12">
          <pr-risk-level-ladder
            [range]="selectedProduct.riskRange"
            size="lg"
          ></pr-risk-level-ladder>
        </div>
      </div>
    </div>
    <div
      #customAction
      class="d-flex gap-s mw-300 flex-col"
      [ngClass]="{ 'd-none': customAction.children.length == 0 }"
    >
      <ng-content select="pr-button"></ng-content>
    </div>
    @if (
      customAction.children.length == 0 &&
      (hasInfos || selectedProduct.routerLink)
    ) {
      <div class="d-flex gap-s">
        @if (selectedProduct.title !== 'FISCALITE IMMOBILIERE' && hasInfos) {
          <pr-button
            clazz="full-w"
            display="neutral"
            size="xl"
            variant="colored"
            label="En savoir +"
            [disabled]="loading"
            (onClick)="
              onDiscover.emit();
              goToRoute(selectedProduct.routerLink.replace('$route', 'docs'))
            "
          >
          </pr-button>
        }
        @if (selectedProduct.routerLink && showSimulation) {
          <pr-button
            clazz="full-w"
            display="neutral"
            size="xl"
            label="Simuler un investissement"
            [disabled]="loading"
            (onClick)="
              onSimulate.emit();
              goToRoute(
                selectedProduct.routerLink.replace('$route', 'simulation'),
                selectedProduct
              )
            "
          >
          </pr-button>
        }
      </div>
    }
  </pr-panel-body>
</pr-panel>
